const formatRange = ({ project, locale, separator, formatValue, keys, }) => {
    return keys
        .map((key) => (!!project[key] ? formatValue(project[key], locale) : ''))
        .filter((i) => !!i.length)
        .join(separator);
};
export default formatRange;
